const getProbeSensorTypes = () => {
  return {
    "EX": true,
  };
}

export default getProbeSensorTypes;
